import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

interface IEmits {
  (event: 'update:modelValue', data: number | string | boolean): void
}

interface IProps {
  modelValue: number | string | boolean
  rootClass?: string | (string | Record<PropertyKey, boolean>)[] | Record<PropertyKey, boolean>
  label?: string
  description?: string
  descriptionClass?: string
  inline?: boolean
  error?: boolean
  errorMessage?: string
  disable?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'KRadio', inheritAttrs: false },
  __name: 'KRadio',
  props: {
    modelValue: { type: [Number, String, Boolean] },
    rootClass: { default: '' },
    label: { default: '' },
    description: { default: '' },
    descriptionClass: { default: '' },
    inline: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errorMessage: { default: 'Required' },
    disable: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {


const props = __props


return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item = _resolveComponent("q-item")!

  return (_openBlock(), _createBlock(_component_q_item, {
    class: _normalizeClass([[__props.rootClass, { inline: __props.inline }], "no-padding unset-min-height column gap-xs"]),
    clickable: false,
    tag: "label",
    "manual-focus": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item_section, {
        class: "no-padding unset-min-width",
        avatar: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_radio, _mergeProps({
            "model-value": __props.modelValue,
            val: "orange",
            color: "space-b-100",
            dense: "",
            class: ['k-radio', 'relative-position', { 'has-error': __props.error }],
            disable: __props.disable
          }, _ctx.$attrs, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }), {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {
                isChecked: __props.modelValue === _ctx.$attrs.val
              }, () => [
                (__props.label)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["q-pl-sm fs-15px fw-500 transition", [
              __props.disable ? 'text-cool-gray-60' : __props.modelValue === _ctx.$attrs.val ? 'text-cool-gray-100' : 'text-cool-gray-70',
            ]])
                    }, _toDisplayString(__props.label), 3))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 3
          }, 16, ["model-value", "class", "disable"])
        ]),
        _: 3
      }),
      (__props.description)
        ? (_openBlock(), _createBlock(_component_q_item_section, { key: 0 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "description", {}, () => [
                _createVNode(_component_q_item_label, {
                  class: _normalizeClass(["radio-description k-radio__texts fs-13px fw-400", [!__props.disable ? 'text-cool-gray-70' : 'text-cool-gray-60']])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.description), 1)
                  ]),
                  _: 1
                }, 8, ["class"])
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      (__props.error)
        ? (_openBlock(), _createBlock(_component_q_item_section, {
            key: 1,
            class: "no-margin"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "error", {}, () => [
                _createVNode(_component_q_item_label, { class: "k-radio__texts fs-13px text-error-100 fw-400" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(__props.errorMessage), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})